Html5Support = LP.module 'Html5Support'

Html5Support.site = ->
  $('[autofocus]:not(:focus)').eq(0).focus()
